import { useEffect, useState } from 'react';
import YourDataModal from './YourDataModal';
import Dialog from '../../components/Dialog';

export const YourDataContainer = () => {
    const [dialogIsOpen, setDialogIsOpen] = useState(false);
    const [ccpaType, setccpaType] = useState<string | null>(null);
    const allowedCcpaTypes = ['disclose', 'delete', 'correct', 'appeal'];

    useEffect(() => {
        const handleModal = (e: any) => {
            if (e.target.classList.contains('privacy-policy--choice')) {
                setDialogIsOpen(!dialogIsOpen);
                const dataType = e.target.getAttribute('data-type');
                if (allowedCcpaTypes.includes(dataType)) {
                    setccpaType(dataType);
                } else {
                    console.error('Invalid ccpaType:', dataType);
                    setccpaType(null);
                }
            }
        };

        const pageContainer: HTMLElement | null = document.querySelector('.privacy-your-data');

        pageContainer?.addEventListener('click', handleModal);

        return () => pageContainer?.removeEventListener('click', handleModal);
    }, [dialogIsOpen]);

    return (
        <Dialog isVisible={dialogIsOpen} onClose={() => setDialogIsOpen(false)}>
            {ccpaType ? <YourDataModal ccpaType={ccpaType} /> : <></>}
        </Dialog>
    );
};
